import React, { useState } from 'react'
import { Divider, Empty, Popconfirm, Table, Tooltip, message } from 'antd'
import { Badge } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faToggleOff, faToggleOn, faTrash } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'

import EditWarehouseModal from './EditWarehouseModal'
import WarehouseDocksModal from '../../WarehouseDocks/partials/WarehouseDocksModal'

import { deleteWarehouse, updateWarehouse } from '../services'
import { handleError } from '../../../helpers'

export default function WarehousesTable({ warehouses, reload }) {
	const [editModal, setEditModal] = useState(null)
	const [warehouseDocksModal, setWarehouseDocksModal] = useState(null)

	const columns = [
		{
			title: 'Código',
			dataIndex: 'sku'
		},
		{
			title: 'Nombre de Bodega',
			dataIndex: 'name'
		},
		{
			title: 'Cantidad de Muelles',
			dataIndex: 'docks_count',
			render: (t, r) => (
				<span>
					{t} muelles{" "}
					<span className='text-link mb-0' onClick={() => setWarehouseDocksModal(r)}>
						| Editar
					</span>
				</span>
			),
		},
		{
			title: 'Estado',
			dataIndex: 'status',
			render: (t, r) => (
				<Badge color={r.status.color}>{r.status.label}</Badge>
			)
		},
		{
			title: 'Acciones',
			width: '100px',
			render: (t, r) => (
				<React.Fragment>
					<Tooltip title={r.disabled_at ? 'Habilitar' : 'Deshabilitar'} className='text-link'>
						<FontAwesomeIcon 
							icon={r.disabled_at ? faToggleOn : faToggleOff} 
							onClick={() => handleToggle(r)} 
						/>
					</Tooltip>
					<Divider type="vertical" />
					<Tooltip title="Editar" className='text-link'>
						<FontAwesomeIcon icon={faEdit} onClick={() => setEditModal(r)} />
					</Tooltip>
					{ r.appointments_count === 0 && (
						<React.Fragment>
							<Divider type="vertical" />
							<Popconfirm
								title="Esta acción no se puede revertir"
								okText="Eliminar"
								cancelText="Cancelar"
								okButtonProps={{ danger:true }}
								onConfirm={() => handleDelete(r.id)}
							>
								<Tooltip 
									title="Eliminar" 
									className='text-link'
									placement='bottom'
								>
									<FontAwesomeIcon icon={faTrash} />
								</Tooltip>
							</Popconfirm>
						</React.Fragment>
					)}
				</React.Fragment>
			)
		}
	]

	const handleDelete = id => {
		deleteWarehouse(id)
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(error => handleError(error))
	}

	const handleToggle = record => {
		updateWarehouse(record.id, { 
			disabled_at: record.disabled_at ? null : moment().format('YYYY-MM-DD HH:mm:ss') 
		})
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(error => handleError(error))
	}

	const expandedRowRender = (record) => {
		return (
			<React.Fragment>
				<p>Dirección: {record.address}</p>
				<p>Fecha de creación: {record.created_at}</p>
				<p>Fecha última actualización: {record.updated_at}</p>
			</React.Fragment>
		)
	}

	return (
		<React.Fragment>
			<Table 
				dataSource={warehouses}
				columns={columns}
				rowKey={r => r.id}
				loading={!warehouses}
				size='small'
				expandable={{ expandedRowRender }}
				locale={{ 
					emptyText: (
						<Empty 
							description="No se encontraron registros" 
							imageStyle={{ height:'80px' }}
						/>
					) 
				}}
			/>
			{ editModal && (
				<EditWarehouseModal 
					visible
					onClose={() => setEditModal(null)}
					reload={reload}
					warehouse={editModal}
				/>
			)}
			{ warehouseDocksModal && (
				<WarehouseDocksModal 
					visible
					onClose={() => setWarehouseDocksModal(null)}
					warehouse={warehouseDocksModal}
					reload={reload}
				/>
			)}
		</React.Fragment>
	)
}